// ** Redux Imports
import { combineReducers } from "redux";

// ** Reducers Imports
import auth from "./auth";
import navbar from "./navbar";
import layout from "./layout";
import customers from "./customers";
import departments from "./departments";
import parties from "./parties";
import countries from "./countries";
import seaPorts from "./seaPorts";
import airPorts from "./airPorts";
import hallNumbers from "./hallNumbers";
import currencies from "./currencies";
import users from "./users";
import procurementTypes from "./procurementTypes";
import processTypes from "./processTypes";
import costTypes from "./costTypes";
import costHeads from "./costHeads";
import productLocations from "./productLocations";
import productCategories from "./productCategories";
import products from "./products";
import sizes from "./sizes";
import containerSizes from "./containerSizes";
import prices from "./prices";
import units from "./units";
import hsns from "./hsns";
import salesOrder from "./salesOrder";
import companies from "./companies";
import salesInvoices from "./salesInvoices";

import documentThrough from "./documentThrough";
import shipments from "./shipments";
import payments from "./payments";
import portOfLoadings from "./portOfLoadings";
import weight from "./weight";
import packingType from "./packingType";
import packingLists from "./packingLists";

import stockInwards from "./stockInwards";

import stockLists from "./stockLists";

import purchaseReceipts from "./purchaseReceipt";

import suppliers from "./suppliers";

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  customers,
  departments,
  parties,
  countries,
  seaPorts,
  airPorts,
  currencies,
  users,
  hallNumbers,
  procurementTypes,
  processTypes,
  costTypes,
  costHeads,
  productLocations,
  productCategories,
  products,
  sizes,
  containerSizes,
  prices,
  units,
  hsns,
  salesOrder,
  companies,
  packingLists,
  salesInvoices,
  documentThrough,
  shipments,
  payments,
  weight,
  packingType,
  portOfLoadings,
  stockInwards,
  stockLists,
  purchaseReceipts,
  suppliers,
});

export default rootReducer;
